/**
 * Block 13 PR-G Phase 6 — thin route wrappers для `/contracts/:id/edit` и
 * `/contracts/:id/pdf`. Извлекают `:id` из `useParams()` и передают в
 * Container'ы (которые принимают `contractId` prop напрямую — Phase 4A/5B
 * API не меняется).
 *
 * Файл отдельный от `router.tsx`, потому что `router.tsx` экспортирует value
 * (`router` instance) — react-refresh правило требует чтобы файл с component
 * экспортами не миксил value exports (иначе HMR fast refresh ломается).
 */

import { Navigate, useParams } from 'react-router-dom';

import { ContractFormContainer } from './ContractFormContainer';
import { ContractPdfPreviewContainer } from './ContractPdfPreviewContainer';

export function ContractEditRoute() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/contracts" replace />;
  return <ContractFormContainer contractId={id} />;
}

export function ContractPdfRoute() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/contracts" replace />;
  return <ContractPdfPreviewContainer contractId={id} />;
}
